import { changeField } from 'publisher/actions/optInActions'
import { useFieldsStorage } from 'publisher/components/entities/Field/hooks/use-fields-storage'
import { useOptIn } from 'publisher/store'
import {
  getFieldErrorsBySlug,
  getFieldValueBySlug,
} from 'publisher/store/opt-in/optInSelectors'
import React from 'react'
import { useDispatch } from 'react-redux'
import {
  BasePublisherBaseField,
  BasePublisherBaseFieldProps,
} from 'src/publisher/entities/base-publisher-field/base-publisher-base-field'

interface BaseFieldNewProps
  extends Omit<BasePublisherBaseFieldProps, 'value' | 'errors' | 'onChange'> {}

const BaseFieldNew = ({ entity, ...props }: BaseFieldNewProps) => {
  const value = useOptIn(state => getFieldValueBySlug(state, entity.slug))
  const errors = useOptIn(state => getFieldErrorsBySlug(state, entity.slug))
  const dispatch = useDispatch()

  useFieldsStorage(entity.slug ?? '')

  return (
    <BasePublisherBaseField
      entity={entity}
      value={value}
      errors={errors}
      onChange={value => dispatch(changeField(entity.slug, value))}
      {...props}
    />
  )
}

export default BaseFieldNew
